import React from 'react';
import { Box, Stack } from '@mui/material';

type EntityProfileLayoutProps = {
  rightColumnElement: React.ReactNode;
  leftColumnElement: React.ReactNode;
  classNameWrapper?: string;
};

const EntityProfileLayout = ({ leftColumnElement, rightColumnElement, classNameWrapper }: EntityProfileLayoutProps) => {
  return (
    <Box
      className={classNameWrapper}
      data-hj-suppress
      sx={theme => ({
        display: 'flex',
        gap: '1rem',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          gap: '1rem',
        },
      })}
    >
      <Box
        sx={theme => ({
          position: 'sticky',
          top: '79px',
          height: 'calc(100vh - 100px)',
          overflowY: 'auto',
          maxWidth: '28rem',
          width: '100%',
          flexShrink: 0,
          padding: '1rem',
          backgroundColor: 'background.paper',
          borderRadius: '0.188rem',
          [theme.breakpoints.down('md')]: {
            position: 'relative',
            top: 'auto',
            height: 'auto',
            maxWidth: 'none',
            flexShrink: 1,
            overflowY: 'visible',
          },
        })}
      >
        <Stack>{leftColumnElement}</Stack>
      </Box>
      <Box
        sx={theme => ({
          width: '100%',
          overflow: 'auto',
          borderRadius: '0.188rem',
          padding: '1rem',
          backgroundColor: 'background.paper',
          position: 'relative',
          [theme.breakpoints.down('md')]: {
            minHeight: '30vh',
          },
        })}
      >
        {rightColumnElement}
      </Box>
    </Box>
  );
};

export default EntityProfileLayout;
